"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;
var _react = _interopRequireDefault(require("react"));
var _config = require("../config");
var _reactRedux = require("react-redux");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Link = function Link(_ref) {
  var children = _ref.children,
    to = _ref.to,
    base = _ref.base,
    target = _ref.target,
    rel = _ref.rel,
    className = _ref.className;
  var local = (0, _reactRedux.useSelector)(function (state) {
    return state.localeReducer.locale;
  });
  var newLink = local === _config.DEFAULT_LOCALE ? "".concat(base).concat(to) : "".concat(base).concat(local, "/").concat(to);
  return /*#__PURE__*/_react.default.createElement("a", {
    href: newLink,
    target: target,
    rel: rel,
    className: className
  }, children);
};
exports.Link = Link;